exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-info a {\r\n    font-size: 45px;\r\n    color: #FFFFFF;\r\n    transition: linear 0.1s;\r\n    line-height: 50px;\r\n}\r\n.mt-info a:hover {\r\n    color: #FC6119;\r\n    transition: linear 0.1s;\r\n}\r\n\r\n.mt-actions .mt-action .mt-action-img > img {\r\n    width: 50px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.css
// module id = 985
// module chunks = 1